import React, { useState, useEffect, useContext } from "react";
import { TimePicker, Row, Col } from "antd";
import dayjs from "dayjs"

export const TimePickerRange = ({
  reportTimeRange,
  setReportTimeRange,
  disabledDates,
}) => {
  let format = "HH:mm";
  const [startSelect, setStartSelect] = useState();
  const [endSelect, setEndSelect] = useState();
  const [valueEndSelect, setValueEndSelect] = useState();

  function removeHighlightMinutes() {
    let li_elements_minutes = document.querySelectorAll(
      ".ant-picker-time-panel > .ant-picker-content > .ant-picker-time-panel-column:nth-child(2) li div",
    );
    li_elements_minutes.forEach((elem) => {
      elem.style = "background-color:unset;";
    });
  }
  console.log(reportTimeRange[0]);
  function removeHighlightHours() {
    let li_elements = document.querySelectorAll(
      ".ant-picker-time-panel > .ant-picker-content > .ant-picker-time-panel-column:first-child  li div",
    );
    li_elements.forEach((elem) => {
      elem.style = "background-color:unset;";
    });
  }
  function resetHours() {
    removeHighlightMinutes();
    removeHighlightHours();
  }
  function addDisabledMinuts(hour, position) {
    console.log(position, "minute");
    console.log(hour, "hour");
    removeHighlightMinutes();
    let li_elements_minutes = document.querySelectorAll(
      ".ant-picker-time-panel > .ant-picker-content > .ant-picker-time-panel-column:nth-child(2) li div",
    );
    disabledDates.forEach((item) => {
      console.log(item);
      let date_start = item.date_start.split("T")[1].split("+")[0].split(":");
      let date_end = item.date_end.split("T")[1].split("+")[0].split(":");
      console.log(date_start, "je");
      if (hour > date_start[0] && hour < date_end[0]) {
        console.log("1", hour);
        li_elements_minutes.forEach((elem) => {
          elem.style = "background-color:red;";
        });
      } else if (hour == date_start[0] && hour == date_end[0]) {
        console.log(hour, "tuuuu", date_start[0], date_end[0], date_start);
        li_elements_minutes.forEach((elem) => {
          if (
            elem.textContent >= date_start[1] &&
            elem.textContent < date_end[1] &&
            position == "start"
          ) {
            console.log("2", elem.textContent);
            elem.style = "background-color:red;";
          } else if (
            elem.textContent >= date_start[1] &&
            elem.textContent < date_end[1] &&
            position == "end"
          ) {
            elem.style = "background-color:red;";
            console.log(date_end[1]);
            console.log("3", elem.textContent);
          }
        });
      } else if (hour > date_start[0] && hour == date_end[0]) {
        li_elements_minutes.forEach((elem) => {
          if (
            elem.textContent < date_end[1] &&
            elem.textContent >= date_start[1] &&
            position == "start"
          ) {
            elem.style = "background-color:red;";
            console.log("4", elem.textContent);
          } else if (
            elem.textContent < date_end[1] &&
            elem.textContent >= date_start[1] &&
            position == "end"
          ) {
            elem.style = "background-color:red;";
            console.log("5", elem.textContent);
          }
        });
      } else if (hour == date_start[0] && hour < date_end[0]) {
        console.log(hour, "hour");
        console.log(hour, date_start[0], date_end[0]);
        li_elements_minutes.forEach((elem) => {
          if (
            elem.textContent >= parseInt(date_start[1]) &&
            elem.textContent <= date_end[1] &&
            position == "start"
          ) {
            elem.style = "background-color:red;";
            console.log("6", elem.textContent);
          } else if (
            elem.textContent <= date_end[1] &&
            elem.textContent >= parseInt(date_start[1]) &&
            position == "end"
          ) {
            elem.style = "background-color:red;";
            console.log("7", elem.textContent);
          }
        });
      }
    });
  }
  let rangeInput = document.querySelectorAll(".ant-picker-range > div");
  if (rangeInput.length > 0) {
    console.lpg("dsads");
    rangeInput[0].addEventListener("click", () => {
      console.log("jsjdasjd jsajd ajs djja");
      addDisableHours("start");
    });
    rangeInput[2].addEventListener("click", () => {
      addDisableHours("end");
    });
  }
  function addDisableHours(position) {
    resetHours();
    setTimeout(() => {
      let li_elements = document.querySelectorAll(
        ".ant-picker-time-panel > .ant-picker-content > .ant-picker-time-panel-column:first-child  li div",
      );
      let li_elements_minutes = document.querySelectorAll(
        ".ant-picker-time-panel > .ant-picker-content > .ant-picker-time-panel-column:nth-child(2) li div",
      );
      disabledDates.forEach((item) => {
        let date_start = item.date_start.split("T")[1].split("+")[0].split(":");
        let date_end = item.date_end.split("T")[1].split("+")[0].split(":");

        li_elements.forEach((elem) => {
          let hour = elem.textContent;
          console.log("hour", elem.textContent);
          elem.addEventListener("click", () => {
            console.log("callll", position);
            addDisabledMinuts(hour, position);
          });
          if (
            elem.textContent > date_start[0] &&
            elem.textContent < date_end[0]
          ) {
            console.log("tuuu", elem);
            elem.style = "background-color:red;";
          }
        });
      });
    }, 100);
  }
  useEffect(() => {
    addDisableHours("start");
  }, [disabledDates]);
  function onChangeStart(e) {
		console.log("CHANGE START", e)
    let newrange = [];

    if (e != null) {
      setStartSelect(e);

      if (valueEndSelect && valueEndSelect.isSameOrAfter(endSelect)) {
        setEndSelect(e);
        setValueEndSelect(e);
        newrange = [...reportTimeRange];
        newrange[0] = e.format("HH:mm");
        newrange[1] = e.format("HH:mm");

        setReportTimeRange(newrange);
      } else {
        newrange = [...reportTimeRange];
        newrange[0] = e.format("HH:mm");

        setReportTimeRange(newrange);
      }
    } else {
      newrange = [...reportTimeRange];
      newrange[0] = "";
      setReportTimeRange(newrange);
    }
  }

  function onChangeEnd(e) {
		console.log("CHANGE END", e)
    setValueEndSelect(e);
    setEndSelect(e);
    let newrange = [];

    if (e != null) {
      newrange = [...reportTimeRange];

      newrange = [...reportTimeRange];
      newrange[1] = e.format("HH:mm");
      setReportTimeRange(newrange);
    } else {
      newrange = [...reportTimeRange];
      newrange[1] = "";
      setReportTimeRange(newrange);
    }
  }

  let getDisabledHours = () => {
    var hours = [];
    console.log("eo gaa", startSelect);
    if (startSelect) {
      for (var i = 0; i < startSelect.hour(); i++) {
        hours.push(i);
      }
    }
    return hours;
  };
  let getDisabledMinutes = (selectedHour) => {
    var minutes = [];
    console.log("eo gaax", startSelect);
    if (startSelect) {
      if (selectedHour === startSelect.hour()) {
        for (var i = 0; i < startSelect.minute(); i++) {
          minutes.push(i);
        }
      }
    }
    return minutes;
  };
  return (
    <>
      <Row>
        <Col span="12">
          <TimePicker
            onOpenChange={() => {
              addDisableHours("start");
            }}
            onChange={onChangeStart}
            value={
              reportTimeRange[0] ? dayjs(reportTimeRange[0], format) : null
            }
            format={format}
          />
        </Col>
        <Col span="12">
          <TimePicker
            onOpenChange={() => {
              addDisableHours("end");
            }}
            onChange={onChangeEnd}
            disabledHours={getDisabledHours}
            disabledMinutes={getDisabledMinutes}
            value={
              reportTimeRange[1] ? dayjs(reportTimeRange[1], format) : null
            }
            format={format}
          />
        </Col>
      </Row>
    </>
  );
};
